import { render, staticRenderFns } from "./wisdom_special.vue?vue&type=template&id=f23a5934&scoped=true&"
import script from "./wisdom_special.vue?vue&type=script&lang=js&"
export * from "./wisdom_special.vue?vue&type=script&lang=js&"
import style0 from "./wisdom_special.vue?vue&type=style&index=0&id=f23a5934&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23a5934",
  null
  
)

export default component.exports